import { createStyles } from "@mantine/core";

const useStyles = createStyles(() => ({
  paymentFailBanner: {
    // width: "calc(100% - 24px)",
    padding: 15,
    backgroundColor: "#DC2626",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "70px",
    gap: 5,
    border: "1px solid #B91C1C",
    // borderRadius: "8px",
    // margin: "8px 12px 0 12px",
    "& .text": {
      color: "#FFF",
      fontFamily: "Inter",
      fontSize: 16,
      fontWeight: 500,
      margin: 0,
      padding: 0,
      "& .link": {
        color: "#FFF",
        textDecoration: "underline",
        cursor: "pointer",
        fontFamily: "Inter",
        fontSize: 16,
        fontWeight: 700,
      },
      "@media (max-width:1140px)": {
        fontSize: 12,
        "& .link": {
          fontSize: 12,
        },
      },
    },
  },
  bannerCloseBtn: {
    marginLeft: "auto",
    flexShrink: 0,
    opacity: 0.8,
    display: "flex",
    alignItems: "center",
    "&:hover": {
      opacity: 1,
    },
  },
  container: {
    display: "flex",
    backgroundColor: "var(--app-header-bg)",
    color: "var(--app-header-text)",
    width: "100%",
    height: "75px",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "1rem",
    borderBottom: "1px solid var(--app-border)",
    boxShadow: "0 1px 2px rgba(0, 0, 0, 0.1)",
    position: "sticky",
    top: 0,
    zIndex: 10,
  },
  left: {
    flex: 1,
    minWidth: 0,
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
    gap: "0.5rem",
    "& h2": {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
  },
  right: {
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "1rem",
    " .mantine-Popover-dropdown": {
      padding: "0 !important",
    },
  },
  hamburger: {
    display: "none",
    background: "none",
    border: "none",
    cursor: "pointer",
    padding: "4px",
    flexShrink: 0,
    alignItems: "center",
    justifyContent: "center",
    "@media (max-width: 768px)": {
      display: "flex",
    },
  },
  notificationBorder: {
    backgroundColor: "var(--app-surface-2)",
    borderRadius: "50%",
    padding: "0.7rem",
    width: "50px",
    height: "50px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    flexShrink: 0,
    "@media (max-width: 480px)": {
      width: "40px",
      height: "40px",
      padding: "0.5rem",
    },
  },
  popoverDropdown: {
    "@media (max-width: 640px)": {
      width: "calc(100vw - 20px) !important",
      maxWidth: "calc(100vw - 20px) !important",
      left: "10px !important",
      right: "10px !important",
    },
  },
  header: {
    display: "flex",
    alignItems: "center",
    gap: "1rem",
    justifyContent: "space-between",
    width: "100%",
    padding: "1rem",
  },
  headerTitle: {
    display: "flex",
    alignItems: "center",
    gap: "1rem",
  },
  body: {
    display: "flex",
    alignItems: "start",
    flexDirection: "column",
    backgroundColor: "var(--app-bg)",
    gap: "1rem",
    width: "100%",
    padding: "1rem",
    maxHeight: "500px",
    overflowY: "auto",
    "@media (max-width: 640px)": {
      maxHeight: "60vh",
      padding: "0.75rem",
    },
  },
  card: {
    display: "flex",
    alignItems: "flex-start",
    flexDirection: "column",
    width: "100%",
    padding: "1rem",
    backgroundColor: "var(--app-surface)",
    borderRadius: "10px",
    border: "1px solid var(--app-border)",
    cursor: "pointer",
  },
  drawerCard: {
    display: "flex",
    alignItems: "flex-start",
    flexDirection: "column",
    width: "100%",
    padding: "1rem",
    backgroundColor: "var(--app-surface)",
    borderRadius: "10px",
    border: "1px solid var(--app-border)",
    gap: "1rem",
    margin: "1rem 0",
    cursor: "pointer",
  },
  titleIndicator: {
    display: "flex",
    alignItems: "center",
    gap: "1rem",
  },
  drawer: {
    ".mantine-Drawer-content": {
      backgroundColor: "var(--app-bg)",
    },
    ".mantine-Drawer-title": {
      fontSize: 20,
      fontWeight: 700,
      fontFamily: "Inter",
      color: "var(--app-text)",
    },
    ".mantine-Drawer-header": {
      backgroundColor: "var(--app-surface)",
    },
  },
  tabs: {
    marginTop: "1rem",
  },
  tabsList: {
    backgroundColor: "var(--app-surface)",
    width: "fit-content",
  },
  empty: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "80vh",
  },
  noNotifications: {
    textAlign: "center",
    width: "100%",
  },
  loaderStyling: {
    display: "block",
    margin: "0 auto",
  },
}));

export default useStyles;
